import { PROFILE_KEYS, getProfile } from '../Product/profile/productProfiles';

export { PROFILE_KEYS };

export const DASHBOARD_PROFILES = {
  [PROFILE_KEYS.COMPETITIVE]: {
    key: PROFILE_KEYS.COMPETITIVE,
    verdict: 'pricePosition',
    viz: 'competitiveness',
    actions: [
      { key: 'repriceUp',    countField: 'total_higher_suggested_price',      route: '#/product?reprice=false',     tone: 'green' },
      { key: 'reprice',      countField: 'total_lower_suggested_price',       route: '#/product?reprice=true',      tone: 'amber' },
      { key: 'variantMatching', countField: 'total_variant_matching_needed',  route: '#/product?variant_matching_needed=true', tone: 'blue' },
      { key: 'stockOut',     countField: 'total_out_of_products',             route: '#/product?mystock=stock_out', tone: 'red' },
      { key: 'noCompetitor', countField: 'total_products_without_competitors', route: '#/product?hasCompetitor=false', tone: 'gray' },
    ],
    sections: ['topCheaperSellers'],
    emptyState: { actionRoute: '#/product?hasCompetitor=false' },
  },
  [PROFILE_KEYS.BRAND]: {
    key: PROFILE_KEYS.BRAND,
    verdict: 'violationSummary',
    viz: 'allowedBand',
    actions: [
      { key: 'mapViolation', countField: 'total_violated_map',                route: '#/product?violation=map', tone: 'red' },
      { key: 'mrpViolation', countField: 'total_violated_mrp',                route: '#/product?violation=mrp', tone: 'red' },
      { key: 'unauthorized', countField: 'total_unauthorized',                route: '#/product?unauthorized=true', tone: 'red' },
      { key: 'noMap',        countField: 'total_no_defined_map',              route: '#/product?noMap=true', tone: 'gray' },
      { key: 'noReseller',   countField: 'total_products_without_competitors', route: '#/product?hasCompetitor=false', tone: 'amber' },
    ],
    sections: ['topViolators', 'unauthorizedSellers'],
    emptyState: { actionRoute: '#/product?hasCompetitor=false' },
  },
  [PROFILE_KEYS.DROPSHIPPING]: {
    key: PROFILE_KEYS.DROPSHIPPING,
    verdict: 'profitLoss',
    viz: 'competitiveness',
    actions: [
      { key: 'notSupplied', countField: 'total_not_supplied_products',   route: '#/product?drop_shipping_supplied=false', tone: 'red' },
      { key: 'loss',        countField: 'total_drop_shipping_loss',       route: '#/report/drop_shipping_loss',            tone: 'red' },
      { key: 'stockOut',    countField: 'total_out_of_products',          route: '#/product?mystock=stock_out',            tone: 'gray' },
      { key: 'repriceUp',   countField: 'total_higher_suggested_price',   route: '#/product?reprice=false',                tone: 'green' },
      { key: 'reprice',     countField: 'total_lower_suggested_price',    route: '#/product?reprice=true',                 tone: 'amber' },
      { key: 'variantMatching', countField: 'total_variant_matching_needed', route: '#/product?variant_matching_needed=true', tone: 'blue' },
    ],
    sections: ['topCheaperSellers'],
    emptyState: { actionRoute: '#/product?hasCompetitor=false' },
  },
  [PROFILE_KEYS.MARKET]: {
    key: PROFILE_KEYS.MARKET,
    verdict: 'plainStatus',
    viz: 'none',
    actions: [
      { key: 'stockOut',   countField: 'total_out_of_products', route: '#/product?mystock=stock_out', tone: 'red' },
    ],
    sections: [],
    emptyState: { actionRoute: '#/product' },
  },
};

// The marketplace operator profile is the competitive dashboard minus the
// "my products out of stock" action: the operator does not sell every tracked
// product, so its stock-0 placeholder rows are not stock-outs. Everything else
// (other actions, sections, verdict, viz, empty state) is the competitive one.
const COMPETITIVE_DASHBOARD = DASHBOARD_PROFILES[PROFILE_KEYS.COMPETITIVE];
DASHBOARD_PROFILES[PROFILE_KEYS.MARKETPLACE] = {
  ...COMPETITIVE_DASHBOARD,
  key: PROFILE_KEYS.MARKETPLACE,
  actions: COMPETITIVE_DASHBOARD.actions.filter((action) => action.key !== 'stockOut'),
};

export const getDashboardProfile = (campaign) => DASHBOARD_PROFILES[getProfile(campaign).key];
